import jazzicon from '@metamask/jazzicon'
import { useEffect, useRef } from 'react'

/**
 * @description
 * metamask icon generate by crypto wallet address
 *
 * ref: https://stackoverflow.com/questions/71678374/get-metamask-profile-picture-and-name-use-web3
 */
export const MetamaskAccountIcon = ({
  walletAddress,
}: {
  walletAddress: string
}) => {
  const avatarRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const element = avatarRef.current
    if (element && walletAddress) {
      const addr = walletAddress.slice(2, 10)
      const seed = parseInt(addr, 16)
      const icon = jazzicon(20, seed) //generates a size 20 icon
      if (element.firstChild) {
        element.removeChild(element.firstChild)
      }
      element.appendChild(icon)
    }
  }, [walletAddress, avatarRef])

  return <div ref={avatarRef}></div>
}
